import { useState } from 'react'

export const useMoveFormToFolder = () => {
  const [open, setOpen] = useState(false)

  return { open, setOpen }
}
